import { useTranslation } from '../i18n';
import NavBarNB from '../components/NavBarNB';
import FooterNB from '../components/FooterNB';
import ContactForm from '../components/ContactForm';
import { useNbTheme } from '../hooks/useNbTheme';

export default function ContactUsPage() {
  const { t } = useTranslation();
  const { colors } = useNbTheme();

  return (
    <div className="min-h-screen flex flex-col bg-nb-cream">
      <NavBarNB />
      <main className="flex-1 max-w-2xl mx-auto px-4 py-16 text-center">
        <h1
          className="text-3xl font-bold font-nb mb-6"
          style={{ color: colors.textPrimary }}
        >
          {t('pages.contact')}
        </h1>
        <div>
          <ContactForm variant="contact" />
        </div>
      </main>
      <FooterNB />
    </div>
  );
}
